import { useState } from 'react';
import Button from '../ui/Button';
import { EditRequestModal, PendingEditBanner } from './StepEditRequest';
import { usePermission } from '../../auth/usePermission';

const EDITABLE_STATUSES = ['completed', 'approved', 'passed', 'rejected', 'failed'];

/**
 * Finished steps (a completed task, or a decision step with its outcome recorded — the outcome
 * itself stays final, only the checklist/fields/remarks can change). Lets a user with 'edit candidate completed step' propose a change to the
 * step's checklist/fields/remarks, and a *different* user with 'approve edit candidate
 * completed step' approve or reject it — nothing on the step changes until approved.
 */
export default function CompletedStepEditPanel({ candidate, step }) {
  const { can } = usePermission();
  const [editOpen, setEditOpen] = useState(false);

  if (!EDITABLE_STATUSES.includes(step.status)) return null;

  return (
    <div className="mt-3">
      <PendingEditBanner candidate={candidate} step={step} />

      {!step.pending_edit_request && can('edit candidate completed step') && (
        <Button variant="secondary" onClick={() => setEditOpen(true)}>
          Edit
        </Button>
      )}

      <EditRequestModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        candidate={candidate}
        step={step}
        fields={step.fields || []}
        sections={step.field_sections || []}
      />
    </div>
  );
}
